/* eslint-disable max-len */
const DATA = [
  {
    type: [
      'USA',
      'React-JS / Native',
      'Node.JS',
      'Flutter',
      'Entertainment',
      'Web Application',
      'Quality Assurance',
    ],
    name: 'A Major Crypto Start-Up<br/><br/>',
    client: 'A Major Crypto Start-Up',
    location: 'USA',
    description:
      '<li>A major Crypto Start-up network allows both Creators and Fans to stake “Coins” on a Blockchain. Creators can create their own sub coin and fans can buy them. Login is supported via twitch.</li><li>NicheSolv has built the entire website feature set : creators and fans, added different login providers like youtube, twitch and facebook,maintained payment processors and setup analytics and GTM events.</li><li> Roles: Development, Devops, QA</li><li> Technologies : Next.js, React-JS, Node.js, Flutter, Dart, Graphql, AWS, Cognito, EKS ( Kubernetes), Github Actions </li>',
    images: ['images/A_Major_Crypto_logo.png'],
  },
  {
    type: ['Design and Architecture'],
    name: 'A Major Crypto Start-Up<br/><br/>',
    client: 'A Major Crypto Start-Up',
    location: 'USA',
    description:
      '<li>NicheSolv chose an architecture based on React-JS & Node.js for front and backend respectively. </li><li>AWS Cognito is used for Authentication & third party authentication integrations.</li><li>Multi-layered GraphQL wraps around multiple microservices.<li>Inter-micro services communication happens using Amazon SQS.</li><li>Inter-service security authorization is done using OPA (Open Policy Agent).   </li>',
    images: ['images/A_Major_Crypto_logo.png'],
  },
  {
    type: ['Devops'],
    name: 'A Major Crypto Start-Up<br/><br/>',
    client: 'A Major Crypto Start-Up',
    location: 'USA',
    description:
      "<li>EKS is used as a container orchestrator.  All the microservices run as docker containers</li><li>Aurora serverless is used as the primary datastore. Each microservice has it's own Aurora serverless cluster which can be scaled individually</li><li>ECR is used for storing the docker images</li><li>ApiGateway is used for publishing and securing APIs</li><li> Cloudfront is being used for delivering contents stored in s3</li><li>For CI/CD, Github Actions is used to build, publish images to ECR and run the microservices in EKS</li>",
    images: ['images/A_Major_Crypto_logo.png'],
  },
  {
    type: ['India', 'Node.JS', 'Entertainment'],
    name: 'Remote Work Tips<br/><br/>',
    client: 'Springworks',
    location: 'India',
    description:
      '<li> Remote work tips is an app on Slack and MS Teams to receive tips on your channel. Users can install this app on their channels and receive useful tips on how to work from home effectively. <br/> NicheSolv has built the MS Teams connectors to get webhook URL of the channels.Subscribers of this app will get tips on their channels everyday.</li> <li> Roles: Development, QA, Hosting, and Managing the Teams App Store deployment  </li><li> Technologies :  Node.js, MongoDB, MS Teams API</li>',
    images: [
      'images/RemoteWorkTipsIcon.png',
      'images/RemoteWorkTips/RemoteWorkTips1.jpg',
      'images/RemoteWorkTips/RemoteWorkTips2.png',
      'images/RemoteWorkTips/RemoteWorkTips3.png',
      'images/RemoteWorkTips/RemoteWorkTips4.jpg',
    ],
  },
  {
    type: ['India', 'Node.JS', 'Entertainment'],
    name: 'Trivia<br/><br/>',
    client: 'Springworks',
    location: 'India',
    description:
      '<li>  Trivia quiz is an app created on Slack and MS Teams to play engaging quizzes with your team on these messaging platform.Get summarised results at the end of every Trivia quiz.<br/>NicheSolv developed this app on MS Teams platform by using MS teams bots to receive answers from users and post appropriate results to the users.</li> <li> Roles: Development, QA, Hosting, and Managing the Teams App Store deployment  </li><li> Technologies :  Node.js, MongoDB, Redis, MS Teams API</li>',
    images: [
      'images/TriviaIcon.png',
      'images/Trivia/TriviaScreenshot2.png',
      'images/Trivia/TriviaScreenshot3.png',
      'images/Trivia/TriviaScreenshot4.png',
      'images/Trivia/TriviaScreenshot5.jpg',
    ],
  },
  {
    type: ['India', 'Node.JS', 'Hiring/L&D'],
    name: 'YANA FB Integration<br/><br/>',
    client: 'ThoughtFocus',
    location: 'India',
    description:
      '<li>  Yana FB Integration was implemented to build chatbot for University students using Facebook messenger. It answers questions on campus events, buildings, persons etc. <br/> NicheSolv developed an app on Facebook messenger using webhooks & messenger components to bridge the chatbot to Facebook users. Response cards formatted using Facebook message templates.</li> <li> Roles: Development </li><li> Technologies :  Node.js, Facebook developer platform</li>',
    images: ['images/ThoughtFocusIcon.png'],
  },
  {
    type: ['India', 'Java', 'Health Care'],
    name: 'Soniflow<br/><br/>',
    client: 'CloudXIM',
    location: 'India',
    description:
      '<li>   ARCore SDK for motion tracking, environmental understanding, and light estimation.</li><li> Augmented Faces API to identify regions of a face. The aim was to calculate distances between certain pairs of points located on the face, creating a virtual face mesh. Both 2D and 3D measurements are recorded.</li> <li> Roles: Development </li><li> Technologies :  Java, Android SDK, ARCore Augmented Faces</li>',
    images: [
      'images/Soniflow/CloudXIM.png',
      'images/Soniflow/Soniflow1.png',
      'images/Soniflow/Soniflow2.png',
      'images/Soniflow/Soniflow3.png',
      'images/Soniflow/Soniflow4.png',
      'images/Soniflow/Soniflow5.png',
      'images/Soniflow/Soniflow6.png',
      'images/Soniflow/Soniflow7.png',
      'images/Soniflow/Soniflow8.png',
      'images/Soniflow/Soniflow9.png',
      'images/Soniflow/Soniflow10.png',
    ],
  },
  {
    type: ['India', 'Java', 'Travel & Leisure'],
    name: 'Pickyourtrail<br/><br/>',
    client: 'Pickyourtrail',
    location: 'India',
    description:
      "<li>   Pick your trail is one of India’s highest-rated travel planners.</li><li>NicheSolv's role in this project was to map the requests and responses for hotel search, room options, location search with different Expedia APIs</li> <li> Roles: Development </li><li> Technologies :  Java, Spring framework, Maven, mapStruct, REST web services</li>",
    images: ['images/Pickyourtrail.png'],
  },
  {
    type: ['Australia', 'React-JS / Native', 'Web Application', 'Hiring/L&D'],
    name: 'Rizoomi<br/><br/>',
    client: 'Rizoomi',
    location: 'Australia',
    description:
      '<li>Rizoomi is a Video and analytics heavy hiring system. The candidate can present selected fragments of  his skills, employment experiences,  & his experience tags in videos. The tool also helps him create videos. The site works both on a B2C model and also a B2B where staffing agencies can manage opportunities and present candidates.  Analytics are provided to both users and organizations.</li> <li> Roles: Development, QA </li><li> Technologies : React-JS, Semantic-UI, React Saga, Netlify CI/CD </li>',
    images: ['images/Rizoomi.png'],
  },
  {
    type: ['India', 'V-CTO', 'Hiring/L&D'],
    name: 'YANA Chatbot<br/><br/>',
    client: 'ThoughtFocus',
    location: 'India',
    description:
      "<li>Yana is a multi lingual chatbot for University students. It answers questions on campus events, courses offered, buildings, persons etc.</li><br>NicheSolv's role:<br/><li>Headed the engineering team</li><li>Evaluated existing code/work </li><li>Made technology choices for future implementations</li><li>Hired engineering candidates</li><li>Setup an agile development process</li><li>Setup an AI lab team for advanced NLP work</li></li>",
    images: ['images/ThoughtFocusIcon.png'],
  },
  {
    type: [
      'India',
      'Java',
      'Web Application',
      'React-JS / Native',
      'Engineering',
    ],
    name: '3vima<br/><br/>',
    client: '3vima',
    location: 'India',
    description:
      "<li>3vima aims to provide project management consultancy services both by using personnel and software tools the personnel would be expert at.They build a project management tool that focuses on essential metrics that would help managers steer projects right at the right time.This web based tool captures project data of multiple projects, has a dashboard to show project progress data.,authenticate users, allows planned, actual and  forecast data to be updated using Excel files using specific template and visual data to be uploaded to the tool.</li><li>NicheSolv's role in the project were<br/>Created pojo structure for functionalities like Narratives, Safety, Risks, Progress, Cost, Schedule Performance, Quantity, Areas of concern. <br/>Evaluated existing code/work <br/>Made technology choices for future implementations<br/>Read excel sheet data for functionalities and populated the values for particular work items and modules.<br/>Written methods to consolidate values to the pojo structure for UI.<br/>Used Java streams to calculate cumulative data for Progress, Cost, Schedule Performance and overall project performance in Summary tab.</br>Worked on AWS environment - handling the entire EC2 setup, deployments & monitor</br>Role: Development</br>Technologies : Java, React-JS, AWS</li>",
    images: [
      'images/3vima/3vimaIcon.jpg',
      'images/3vima/3vima1.png',
      'images/3vima/3vima2.png',
      'images/3vima/3vima3.png',
      'images/3vima/3vima4.png',
    ],
  },
  {
    type: [
      'Web Application',
      'Mobile Application',
      'Health Care',
      'India',
      'Python',
      'PHP',
      'vCTO',
    ],
    name: 'Personal<br/> Air Quality Systems',
    client: 'PAQS',
    location: 'India',
    description:
      '<li><a href="http://www.paqs.biz" target="_blank"><b>PAQS</b></a> has IOT enabled solutions\r\n (hardware and cloud based software) to monitor and report on air quality.\r\n </li>\r\n <li>NicheSolv is the technology partner taking care of the cloud side software.</li>\r\n <li> Solutions are currently deployed in multiple cities,\r\n and are integrated with smart city platforms such as the Cisco CDP. The work includes<br>\r\n - Prediction of pollution levels from past data using linear regression/ neural nets<br>\r\n - API endpoint development to provide sensor data<br>\r\n - EMS to manage/monitor the various devices<br>\r\n - Apps to provide AQI and device data to the end consumer<br>\r\n - App for Asthma patients to track inhaler use, and correlate with air quality data<br>\r\n </li>\r\n <li>Roles: Development/design/architecture and project execution</li>\r\n <li>Technologies: Python, PHP, Java, Spring, Elastic Search, MQTT, Amazon AWS</li>',
    images: [
      'images/PAQS logo.jpg',
      'images/paqs/AQI-Dashboard.png',
      'images/paqs/TrackAir App 2.png',
      'images/paqs/01_Login.png',
      'images/paqs/03_Canister details filled.png',
      'images/paqs/05_Notifications.png',
      'images/paqs/06_Inhaler List.png',
      'images/paqs/10_Record_Triggers_1.png',
      'images/paqs/11_Record_Triggers_2.png',
      'images/paqs/13_Record_FeelsLike.png',
    ],
    // about: '<a href="http://www.paqs.biz" target="_blank">Personal Air Quality Systems Private Limited (PAQS)</a> is a technocrat startup,  a certified ESDM company which provides a bouquet of solutions (bio-medical & diagnostic devices*) that capture real time environment data and provides personalised analytics around ‘inhaled air’ that enables healthy living.<br/>',
  },
  {
    type: ['Web Application', 'Airlines', 'USA', 'HTML / Bootstrap'],
    name: 'Rossch Group<br/>Airline Crew Management',
    client: 'Rossch Group',
    location: 'Dallas, USA',
    description:
      '<li><a href="http://www.rossch.com" target="_blank"><b>Rossch Group</b></a>, Dallas ( Airlines Operations ) - We have designed & developed crew management software along with identity management platform for in-flight operations</li><li>Functionality covered employee &amp; admin roles. </li>\r\n <li>Employee: Crew Legality, Detailed Schedule,\r\n Dashboard, Airport Status, Map View to show airports current status.\r\n </li>\r\n <li>Admin: Crew Roster, File Management, Crew Messaging, Vacancy Config, Vacancy Awards, Vacation Config and Vacation Awards.</li>\r\n <li>Roles: Development and Testing</li>\r\n <li>Technologies: Angular JS, HTML5, Bootstrap, Javascript, Google Maps api, Java, Spring, Hibernate, StormPath ( Identity Mgmt platform)</li>',
    images: [
      'images/rossch.jpg',
      'images/rossch/admin_dashboard.png',
      'images/rossch/crew_member_listing.png',
      'images/rossch/file_managemwnt.png',
      'images/rossch/login.png',
      'images/rossch/messages.png',
      'images/rossch/user_dashboard.png',
      'images/rossch/vacancy_submission.png',
    ],
    // about: 'website: <a>http://www.rossch.com</a>',
  },
  {
    type: [
      'Web Application',
      'Quality Assurance',
      'Travel & Leisure',
      'India',
      'Python',
    ],
    name: 'GoIbibo.com<br>travel portal',
    client: 'GoIbibo',
    location: 'India',
    description:
      '<li>NicheSolv has implemented \u2018parsers\u2019 - connecting the GoIbibo search/booking engine to other\r\n travel suppliers via SOAP.\r\n </li>\r\n <li>A User search on GoIbibo is transmitted to partners via a SOAP interface. Subsequent calls for booking, cancelling, verification of booking, etc. also are handled.</li>\r\n <li>Projects also done to connect Meals, Baggage &amp; Seat Selection APIs of various vendors like\r\n Navitaire(Indigo/SpiceJet), Air Arabia, Go Air, etc. to the GoIbibo framework.\r\n </li>\r\n <li>Roles: Development</li>\r\n <li>Technologies: Python, Django, XML-SAX/DOM Parsers, SOAP</li>',
    images: ['images/goibibo.jpg', 'images/goibibothumb.jpg'],
  },
  {
    type: [
      'Application',
      'Design and Architecture',
      'Innovation',
      'USA',
      'Java',
    ],
    name: 'Amick Brown<br/>Resiliency evaluation engine',
    client: 'Amick Brown',
    location: 'San Ramone, USA',
    description:
      '<li>NicheSolv is currently building an engine to evaluate the resiliency of supply chains for <a href="https://amickbrown.com" target="_blank"><b>Amick Brown</b></a>. The engine\r\n model has been devised by a professor at the University of Illinois. It evaluates stockout probabilities,\r\n and optimum stock levels to accomplish various objectives such as demand percentage,\r\n end product demand, inventory cost &amp; total annual cost.\r\n </li>\r\n <li>1. Input - Import data from a daily data dump</li>\r\n <li>2. Engine - Evaluate the material dependency tree and perform computations</li>\r\n <li>3. Output - Store data into the OLAP system for reporting/display to users</li>\r\n <li>4. Http REST interface for starting computations, or sending incremental compute requests</li>\r\n <li>Roles: Design/Development &amp; Testing ( automation)</li>\r\n <li>Technologies: Java, Spring</li>',
    images: ['images/AmickBrown.jpg', 'images/AmickBrownthumb.png'],
  },
  {
    type: [
      'Web Application',
      'Design and Architecture',
      'Quality Assurance',
      'Networking',
      'India',
      'Java',
    ],
    name: 'Cisco<br>Hardware app sizing',
    client: 'Cisco',
    location: 'Bangalore, India',
    description:
      '<li>NicheSolv is heading the execution of building a multi-user, multi-role, web based hardware sizing\r\n tool. The tool has been live since Sep 2013 for Cisco employees &amp; partners. It helps users figure out\r\n appropriate Blade/Rack server configurations for large applications such as SAP, PeopleSoft,\r\n Oracle, Exchange, Sharepoint etc.\r\n </li>\r\n <li>Roles: Architecture, Design, Team Management, Project Management, Development, Test Automation, Manual Testing, Staffing</li>\r\n <li>\r\n Technologies: Java, Spring 3.x, Hibernate, Spring-security, Spring-MVC, Spring-webflow,\r\n XWT(Cisco\u2019s customization of Dojo), Dojo, Selenium Webdriver\r\n </li>',
    images: [
      'images/ucs.jpg',
      'images/cisco/SAP_Basic.png',
      'images/cisco/SAP_Build_Config.png',
      'images/cisco/SAP_Edit_Config.png',
      'images/cisco/SAP_Installation.png',
      'images/cisco/SAP_Landscape.png',
      'images/cisco/SAP_Server_Config.png',
      'images/cisco/SAP_Summary.png',
    ],
  },
  {
    type: ['Web Application', 'Networking', 'USA', 'Java', 'React-JS / Native'],
    name: 'Lumos Systems<br>(Cisco Project)',
    client: 'Lumos Systems (Cisco Project)',
    location: 'California, USA',
    description:
      '<li>A sizing tool to help Cisco partners &amp; sales engineers create sizings for BigData applications\r\n such as Splunk, Hadoop &amp; Kafka. The solution is a single page application (SPA) that displays\r\n computation results as the user changes input data.\r\n </li>\r\n <li>Splunk Sizer: Users enter input data size, data retention duration, archival duration, cluster replication\r\n desired, desired servers, cpus, disks and the Raid level.\r\n </li>\r\n <li>Hadoop/Kafka: Users will input details of the distribution ( MapR/ Cloudera/Hortonworks), server\r\n of choice, disk size, input data size, compression expected, etc. The system will emit the desired\r\n hardware &amp; network configuration with part numbers and pricing.\r\n </li>\r\n <li>Roles: Requirements Analysis, UI Design, Design, Development, Testing &amp; project execution</li>\r\n <li>Technologies: React-JS, Java, Spring 3.x, Hibernate, Spring-security, Spring-MVC\r\n </li>',
    images: [
      'images/Lumosthumb.jpg',
      'images/cisco/hadoop_home.jpg',
      'images/cisco/hadoop_buildconfig.jpg',
      'images/cisco/hadoop_buildconfig1.jpg',
      'images/cisco/hadoop_questionnaire.jpg',
      'images/cisco/splunk_home.jpg',
      'images/cisco/splunk_build_config.png',
      'images/cisco/splunk_build_config2.png',
      'images/cisco/splunk_edit.jpg',
      'images/cisco/splunk_questionnaire.jpg',
    ],
  },
  {
    type: [
      'Web Application',
      'Entertainment',
      'USA',
      'PHP',
      'HTML / Bootstrap',
    ],
    name: 'Rchive<br>Screenplay Management',
    client: 'Rchive',
    location: 'Hollywood, USA',
    description:
      '<li><a href="https://www.rchive.co/" target="_blank"><b>Rchive</b></a> allows screenplay writers upload and share their screenplays without fear of plagiarism.\r\n The system is a community of screenplay writers and also industry professionals who can\r\n find screenplays that are best voted by the writers community\r\n </li>\r\n <li>Roles: Architecture, Design, Team Management, Development, Test Automation</li>\r\n <li>Technologies: PHP, CodeIgniter, HTML, CSS, Javascript, Mysql</li>',
    images: [
      'images/6902.jpg',
      'images/Rchive/ActivityLogPage.png',
      'images/Rchive/DashBoardPage.png',
      'images/Rchive/HomePage.png',
      'images/Rchive/SecurityPage.png',
      'images/Rchive/SmartSharePage.png',
      'images/Rchive/TeamPage.png',
    ],
  },
  {
    type: [
      'Web Application',
      'Entertainment',
      'India',
      'Java',
      'HTML / Bootstrap',
      'Mobile Application',
    ],
    name: 'Jus’ Play Profile/Tournament <br>Mgmt in Tennis',
    client: 'Jus’ Play Profile/Tournament Mgmt in Tennis',
    location: 'Bangalore, India',
    description:
      '<li>Phase 1 of the product has been implemented.</li>\r\n <li>Organizations - Officers, Location, Courts &amp; Points of Interest.</li>\r\n <li>Tournament - creation, progress dashboard</li>\r\n <li>User registration - Organizations &amp; Player Managers</li>\r\n <li>Next phase: Creating draws, Allowing users to make payments, pulling player profiles &amp; tournaments from the Tennis federation website.</li>\r\n <li>Technologies: React JS, Apache Cordova, HTML, Bootstrap, Java, Spring, MongoDB</li>',
    images: [
      'images/jusplay_thumb.jpg',
      'images/jus_play/Jusplay upcoming tournament-compressed.jpg',
      'images/jus_play/RefereeDashboard-compressed.jpg',
      'images/jus_play/JusplayCommonDashboard-compressed.jpg',
      'images/jus_play/Jusplay org ongoing tournament-compressed.jpg',
      'images/jus_play/add_venue.png',
      'images/jus_play/dashboard1.png',
      'images/jus_play/dashboard2.png',
      'images/jus_play/organization-listing.png',
      'images/jus_play/point_of_interest.png',
      'images/jus_play/save_court.png',
    ],
  },
  {
    type: ['Web Application', 'Health Care', 'Europe', 'Java'],
    name: 'Symeo<br>Patient Care System',
    client: 'Symeo',
    location: 'France',
    description:
      '<li>Symeo had tasked NicheSolv with building a patient management system for those kinds of patients that require long term care - both physical and mental. The system is to be used by multiple\r\n patient care centers across France. The system has the following modules<br>\r\n 1). Patient: Care history, Skill Evaluation, Education record, Job, Financial Resources,\r\n Relatives,Transport<br>\r\n 2). Settings: Health, Institution, Predefined lists, Supporting documents required, Territorial structure(geography), Transport<br>\r\n 3). Contact Directory: Organization, School, Health office, External contractors<br>\r\n </li>\r\n <li>Roles: Development &amp; Testing (manual &amp; automation)</li>\r\n <li>Technologies: Java, Spring Framework, ZK UI Framework, Hibernate, MS SqlServer</li>',
    images: [
      'images/synox.jpg',
      'images/symeo/document.png',
      'images/symeo/enduser_list.png',
      'images/symeo/mft.png',
      'images/symeo/organization.png',
      'images/symeo/organization_editmode.png',
      'images/symeo/organization_view_mode.png',
      'images/symeo/save_end_user.png',
    ],
  },
  {
    type: ['Web Application', 'Innovation', 'Japan', 'HTML / Bootstrap'],
    name: 'Metis Consultants<br>educational app',
    client: 'Metis Consultants',
    location: 'Tokyo, Japan',
    description:
      '<li>NicheSolv wrote interactive educational javascript apps that\r\n the user could play with, or act as quizzes for <a href="http://www.metis-japan.com/" target="_blank"><b> Metis</b></a>. Some examples were\r\n </li>\r\n \u2022 MS Paint-like app to show how images are distributed across pixels\r\n <br>\u2022 Explaining how circuit breakers work\r\n <br>\u2022 Electronic circuits - Battery /Resistors\r\n <br>\u2022 Power distribution across circuits ( Wattages/Voltages &amp; Current)\r\n <br>\u2022 Food &amp; Nutrition\r\n <br>\u2022 Gears, Weights and mechanical advantages\r\n <li>Roles: Development &amp; Testing</li>\r\n <li>Technologies: HTML5 (DOM and Canvas manipulation), Javascript, Bootstrap, JQuery</li>',
    images: [
      'images/MetisLogo.jpg',
      'images/metis/metis1.gif',
      'images/metis/metis2.gif',
      'images/metis/metis3.gif',
      'images/metis/metis5.gif',
      'images/metis/metis6.gif',
    ],
  },
  {
    type: [
      'Web Application',
      'Travel & Leisure',
      'USA',
      'Java',
      'HTML / Bootstrap',
    ],
    name: 'Unboundly<br>Travel MetaSearch',
    client: 'Unboundly',
    location: 'USA',
    description:
      '<li>This is an Air Meta Search POC built to allow air searches across multiple search providers. The\r\n vision of the system is to provide better pricing by putting in proprietary algorithms.\r\n </li>\r\n <li>Roles: Architecture, Design, Team Management, Development, Testing</li>\r\n <li>Technologies: Angular JS, Bootstrap, Java, Spring-security, Spring-MVC, MongoDB</li>',
    images: ['images/unbondly_thumb.jpg', 'images/unbondly.jpg'],
  },
  {
    type: [
      'Web Application',
      'Design and Architecture',
      'Innovation',
      'USA',
      'Java',
      'HTML / Bootstrap',
    ],
    name: 'ARK<br>Innovation Management',
    client: 'Ark Consulting',
    location: 'Seattle, USA',
    description:
      '<li>Ark wanted an idea management platform POC built quickly. The system allows management to\r\n propose challenges to their organization, and employees to contribute &amp; browse ideas that solve\r\n these challenges.\r\n </li>\r\n <li>Roles: Architecture, Design, Team Management, Development</li>\r\n <li>Technologies: Angular JS, Bootstrap.js, Java, Spring-security, Spring-MVC, MongoDB</li>',
    images: [
      'images/ark.jpg',
      'images/ark/ark.png',
      'images/ark/ark1.png',
      'images/ark/add_campaigns.png',
      'images/ark/add_idea.png',
      'images/ark/future-ready-impact.png',
      'images/ark/relevance-profile.png',
      'images/ark/user_profile.png',
    ],
  },
  {
    type: ['Web Application', 'B2B & E-Commerce', 'Ruby', 'USA'],
    name: 'SEORadar<br/>Web Application',
    client: 'SEORadar',
    location: 'USA',
    description:
      '<li>Tools save the HTML snapshots, also store server response and page render metrics. Extended Search Console Archive Search console reports are limited to the top 1000 pages or keywords. VIA the API, we have access to as far more data, as much as 10,000+ pages. While the Search Data is great inside of Search Console, Google only provides that data for 90 days. We archive it for as longs as 12 months with our enterprise version</li>\r\n <li>Roles : Development, Architecture, Product management and QA</li>\r\n<li>Technologies : Ruby on Rails, Rabbit MQ</li>',
    images: ['images/seoradar.jpg', 'images/seoradar.png'],
  },
  // {
  //   type: ['Web Application', 'B2B & E-Commerce', 'India'],
  //   name: 'HomeAdda<br>Home Buyers portal',
  //   client: 'HomeAdda',
  //   location: 'Bangalore, India',
  // description: '<li>A real estate portal to allow a user to search for new real estate projects on sale.</li>\r\n <li>Roles: Architecture, Design, Team Management, Development, Testing</li>\r\n <li>Technologies: JSF 2.2x, Primefaces 4.0, Spring , Hibernate.</li>',
  //   images: ['images/HomeAdda.jpg', 'images/25 (1).jpg'],
  // },
  {
    type: [
      'Mobile Application',
      'Travel & Leisure',
      'Europe',
      'React-JS / Native',
    ],
    name: 'eFastrack<br/>France',
    client: 'eFastrack',
    location: 'France',
    description:
      '<li>NicheSolv has built mobile app on react- native / iOS platform which is used to book fast rack / lounge pass for a selected airport using stripe payment gateway. Passes can be generated for multiple guests .Each pass contains a QRcode.</li><li>The other features include airport listing, mark airport as favourite and profile settings.</li>\r\n <li>Roles : Design, Development, Testing &amp; Deployment</li>\r\n<li>Technologies : React-Native, iOS</li>',
    images: [
      'images/efastrack/efastrack.jpg',
      'images/efastrack/efastrack1.jpg',
      'images/efastrack/efastrack2.jpg',
      'images/efastrack/efastrack3.jpg',
      'images/efastrack/efastrack4.jpg',
      'images/efastrack/efastrack5.jpg',
      'images/efastrack/efastrack6.jpg',
      'images/efastrack/efastrack7.jpg',
      'images/efastrack/efastrack8.jpg',
    ],
  },
  {
    type: [
      'Mobile Application',
      'Design and Architecture',
      'Travel & Leisure',
      'Japan',
      'Java',
    ],
    name: 'WeHub <br/>Mobile Application',
    client: 'WeHub',
    location: 'Japan',
    description:
      '<li>A \u2018Uber for Tour guides\u2019 IOS apps that allow tourists to find guides fluent in\r\n the language of their choice and take tours. The solution consists of a Tourist App, a Tour Guide\r\n App and the server component with which both apps interact.\r\n </li>\r\n <li>\tA tourist can in any location search for guides, check their profiles/rates, chat with them, take the\r\n tour and finally make payment &amp; provide feedback. The guide - when online - can receive tour\r\n requests and ends up meeting the tourist at tour points, and conducts the requested tour.\r\n </li>\r\n <li>Technologies: Swift IOS SDK, QR Code integration, Payment integration, Java, Spring framework,\r\n Hibernate/JPA, Mysql\r\n </li>',
    images: [
      'images/wehub/thumb.jpg',
      'images/wehub/1.jpg',
      'images/wehub/2.jpg',
      'images/wehub/3.jpg',
      'images/wehub/4.jpg',
      'images/wehub/5.jpg',
      'images/wehub/6.jpg',
      'images/wehub/7.jpg',
      'images/wehub/8.jpg',
      'images/wehub/9.jpg',
      'images/wehub/10.jpg',
      'images/wehub/11.jpg',
    ],
  },
  {
    type: ['Mobile Application', 'Travel & Leisure', 'USA', 'Python', 'PHP'],
    name: 'BYEH<br>Best You’ve Ever Had',
    client: 'BYEH',
    location: 'California',
    description:
      '<li>Byeh aims to build a platform that captures the best boutique consumer experience a user has\r\n had, and allows his network to access that information. The initial vertical chosen is food. The\r\n user can find item sources( restaurants), and add or vote on items(menu items). Other users can\r\n see these votes in their geographic vicinity, and make suitable eating choices. The project was\r\n to:<br>\r\n \u2022 Write get food dish data from wikipedia and clean up the data, attach them to restaurants got\r\n through 3rd party APIS( Zomato/Factual) &amp; import this data into MySQL and ElasticSearch.<br>\r\n \u2022 Build the REST services to this data, and allow voting from the apps (IOS and Android), and\r\n test code to sanity test them.<br>\r\n \u2022 Build the IOS app using Objective-C\r\n </li>\r\n <li>\r\n Roles: Design/Development/Testing/Deployment\r\n </li>\r\n <li>Technologies: iOS Objective-C SDK, Python, PHP, ElasticSearch, Amazon AWS, Swagger</li>',
    images: [
      'images/byeh/logo.jpg',
      'images/byeh/edit_profile.png',
      'images/byeh/Add_dish_1.png',
      'images/byeh/nearby.png',
    ],
  },
  // {
  //   type: ['Web Application', 'Others', 'USA', 'React-JS / Native', 'HTML / Bootstrap'],
  //   name: 'Lucky Divorce <br/> Boutique application',
  //   client: 'Lucky Divorce',
  //   location: 'San Francisco, USA',
  //   description: '<li>Lucky Divorce is a boutique application aimed at helping friends of a divorcee to pool money or\r\nresources and help him to move on.\r\n    </li>\r\n      <li>Roles: Development - UI &amp; Backend</li>\r\n        <li>Technologies: Go, React-JS, HTML5, Postgres</li>\r\n ',
  //   images: ['images/gene.jpg', 'images/ldc/ldc.png', 'images/ldc/ldc-login.png', 'images/ldc/ldc-main.png', 'images/ldc/ldc-main1.png', 'images/ldc/ldc-signup.png', 'images/ldc/ldc-campaign-view.png', 'images/ldc/ldc-campaigns.png', 'images/ldc/ldc-campaign-donate.png'],
  // },
  // {
  //   type: ['Web Application', 'Networking', 'USA', 'Java', 'HTML / Bootstrap'],
  //   name: 'Vello Systems<br>(Sonus Networks)',
  //   client: 'Vello Systems',
  //   location: 'Menlo Park',
  //   description: '<li>Vello Systems was building an a device to be controlled by an SDN controller. NicheSolv built the\r\n log event viewer which is part of Vello Systems\u2019 next generation SDN based management console.\r\n The events that would come from the devices would be stored as documents in a Lucene\r\n Index. The user would be allowed to look at and filter events based on severity, source, and\r\n many other event fields.\r\n </li>\r\n <li>Roles: Design, Team Management, Development</li>\r\n <li>Technologies: Java, JEE 6, JSF 2.0, Prime Faces, HTML, Solr/Lucene, Atmosphere Framework</li>',
  //   images: ['images/vello_thumb.jpg', 'images/vello.jpg'],
  // },
  {
    type: ['Web Application', 'Innovation', 'India', 'Java'],
    name: 'Arnetta<br>Plant Breeding System',
    client: 'Arnetta',
    location: 'India',
    description:
      '<li><a href="http://www.arnettatech.com/" target="_blank"><b>Arnetta</b></a> - A solution is being built to manage hybrid creation, and experiment results in the seed industry.</li>\r\n <li>Roles: Architecture, Design, Team Management, Development</li>\r\n <li>Technologies: Vaadin 7.x, Java, Android, Spring Framework, Spring Security</li>',
    images: ['images/plantbreed_thumb.jpg', 'images/plantbreed.jpg'],
  },
  // {
  //   type: ['Design and Architecture', 'B2B & E-Commerce', 'India', 'Java'],
  //   name: 'OutDu Media<br>UML Design',
  //   client: 'OutDu Media',
  //   location: 'India',
  //   description: '<li>NicheSolv was involved in the architecture/design &amp; modeling of a large scale ad campaign\r\n management platform that will enable Ad agencies to buy time/space on assets such as Billboards,\r\n Digital Signages, TV Channels, Cinema halls, and Radio shows.\r\n </li>\r\n <li>\r\n NicheSolv has also evaluated and made recommendations on frameworks/technologies to use in\r\n building the system.\r\n </li>\r\n <li>\r\n Roles: Requirements Modelling, Object Modelling, Architecture, Design, Framework POCs\r\n </li>\r\n <li>Technologies: UML, Java, Spring 3.x, Hibernate, Spring-MVC, Spring-security</li>',
  //   images: ['images/22383_thumb.jpg', 'images/22383.jpg'],
  // },
  {
    type: ['Web Application', 'Networking', 'USA', 'HTML / Bootstrap'],
    name: 'Nutanix<br>ROI Tool',
    client: 'Nutanix',
    location: 'San Jose, CA',
    description:
      '<li>Nutanix provides VDI solutions in a box, and sells to specific industry verticals such as healthcare.</li>\r\n <li>ROI Calculator: They required an ROI calculator that would help sales partners to input customer\r\n requirements and generate customized ROI reports they could present to customers.\r\n </li>\r\n <li>Product Management Intranet: The Product Management team\u2019s intranet hosted on their internal\r\n google sites instance needed to be redesigned so users could add pages into the system, and\r\n they would show up in a dynamic menu/google gadget.\r\n </li>\r\n <li>\r\n Technologies: Google Apps Scripts, Google Doc/Spreadsheet/Drive APIs, HTML, JQuery\r\n </li>',
    images: ['images/roi_thumb.jpg', 'images/roi.jpg'],
  },
  {
    type: ['Mobile Application', 'B2B & E-Commerce', 'India'],
    name: 'Softvent<br>infovault',
    client: 'Softvent',
    location: 'Bangalore, India',
    description:
      '<li>Softvent has a generic data capture platform for small/medium businesses that can generate\r\n apps such as simple accounting, inventory, sales order entry, etc. NicheSolv is building an Android\r\n framework that generates data entry &amp; listing screens dynamically based the kind of application that is to be run.\r\n </li>\r\n <li>Roles: Design, Development</li>\r\n <li>Technologies: Android 4.1.x, SQLite</li>',
    images: [
      'images/softevn.jpg',
      'images/softvent/dashboard.png',
      'images/softvent/categories.png',
      'images/softvent/export.png',
      'images/softvent/import.png',
      'images/softvent/settings.png',
    ],
  },
  {
    type: [
      'Web Application',
      'Quality Assurance',
      'Entertainment',
      'USA',
      'HTML / Bootstrap',
    ],
    name: 'Roblox<br>Automation Testing',
    client: 'Roblox',
    location: 'San Mateo, CA',
    description:
      '<li>ROBLOX is the #1 ranked kids entertainment site in the US, drawing over one billion page views\r\n and 21 million in-game hours each month.\r\n </li>\r\n </li>\r\n NicheSolv wrote automated tests using C# Dot Net &amp; Selenium 2 to test out their website functionality.</li>\r\n <li>Roles: Test Automation Framework Design/Development, Test Automation</li>\r\n <li>Technlogies: C#.Net, Selenium (Webdriver), HTML, Css, Javascript</li>',
    images: ['images/roblox_thumb.jpg', 'images/roblox1.jpg'],
  },
  {
    type: ['Web Application', 'Entertainment', 'USA', 'Java'],
    name: 'Tivo<br>Server side Engineering',
    client: 'Tivo Inc.',
    location: 'Alviso, CA',
    description:
      '<li>Tivo is the premier DVR provider in the USA.</li>\r\n <li>NicheSolv worked on their server side platform involving code in Java, C++ &amp; Perl. The work involved building new features, bug fixes, performance improvement, monitoring &amp; admin tools,\r\n etc. spread across technologies like Java, JDBC, XML, building Web services, etc.\r\n </li>\r\n <li>When Tivo wanted offshore operations with a large partner, NicheSolv was involved in interviewing/staffing\r\n the team at Wipro, and bringing their engineers upto speed on the technology involved.\r\n </li>\r\n <li>NicheSolv was also involved in evaluating their other offshore teams at vendors such as Tavant.</li>\r\n <li>Technologies: Java, C++, Perl, XML, JAX-RPC, WSDL, Webservices, SQL</li>',
    images: ['images/tivo_thumb.jpg', 'images/tivo2.jpg'],
  },
  {
    type: [
      'Mobile Application',
      'BFSI',
      'India',
      'React-JS / Native',
      'HTML / Bootstrap',
    ],
    name: 'Pension Management & <br/>Securities Depository Firm',
    client:
      'Country`s Largest Pension Management & Securities Depository Firm, Mumbai',
    location: 'India',
    description:
      '<li> NicheSolv has developed a mobile app on Windows / iOS platform for Country`s largest pension management & securities firm.</li>\r\n <li>Features include statement of holdings, list of contributions, contribution towards the scheme, tier 2 withdrawals, support for English / Hindi language, forgot / reset password, mailing statement of transaction for a particular financial year</li>\r\n<br/><li> NicheSolv developed (UID Solution) for Iris Matcher Development (C++) & Verification Library Project </li> <br/><li>Roles: Architecture, Design, Team Management, Development, Testing</li>\r\n <li>Technologies : React, HTML, Bootstrap, CSS, JQuery, Cordova</li>',
    images: ['images/pension.png'],
  },
  // {
  //   type: ['Web Application', 'BFSI', 'USA', 'HTML / Bootstrap'],
  //   name: 'Unbent Media<br>IVR/web loan application',
  //   client: 'Unbent Media',
  //   location: 'Redwood City, CA',
  //   description: '<li>Unbent Media has several finance-related services/products.</li>\r\n <li>NicheSolv built a phone based IVR system hosted on Callfire.com &amp; the linked website - both\r\n collect data for small loan applications, and handoff users to appropriate loan vendors. The system\r\n was built to handle US, GB &amp; Canadian locales with locale specific custom data fields, custom\r\n validations, and skinning.\r\n </li>\r\n <li>Roles: Architecture, Design, Team Management, Development, Testing</li>\r\n <li>Technologies: Grails, Groovy, HTML, Css, XML, SSL, Callfire IVR XML, Hibernate, Spring, Quartz</li>',
  //   images: ['images/ivr_thumb.jpg', 'images/ivr.jpg'],
  // },
  // {
  //   type: ['Web Application', 'Airlines', 'USA', 'HTML / Bootstrap'],
  //   name: 'Ascension Air <br/> Airline',
  //   client: 'Ascension Air',
  //   location: 'Atlanta GA',
  //   description: '<li>NicheSolv developed responsive and Angular JS based screens for their Crew Management System and Admin Site. We did the screens for Crew Legality, Detailed Schedule, Dashboard, Airport Status, Map View to show airports current status on the Crew Management System Side.On the admin side we did screens like Crew Roster, File Management, Crew Messaging, Vacancy Config, Vacancy Award,Vacation Config and Vacation Award.</li>\r\n <li>Technologies: HTML, CSS, Jquery, Javascript and Angular JS</li>\r\n<li>Role: UI Developer, Client Interface</li>',
  //   images: ['images/ascension_air_thumb.jpg', 'images/ascension_air.jpg'],
  // },
  // {
  //   type: ['Web Application', 'Airlines'],
  //   name: 'Medium size airline<br/>Airline',
  //   client: 'Airline',
  //   location: 'Japan',
  //   description: '<li>ACARS M16 messages were not updating Movement Control due to unsupported message format. Users were updating the ETE time and ETA time manually in Movement Control for each flight. To automate this process NicheSolv wrote a M36 to ETA message convertor.The implementation also included Export/Import of M36,SSIM /ASM messages from Peach FTP location.The SSIM / ASM files were parsed to get the destination data missing in M36 using the flight number which was to be included in the converted ETA.</li>\r\n <li>Technologies: Spring Data JPA, MySQL, Amazon SQS, Antlr grammar</li>\r\n<li>Role: Developer - Backend (Message conversion using Antlr )</li>',
  //   images: ['images/medium_size_airline.jpg', 'images/no_image.png'],
  // },
  // {
  //   type: ['Web Application', 'Airline'],
  //   name: 'Peach Aviation<br/>Japan',
  //   client: 'Peach Aviation',
  //   location: 'Japan',
  //   description: '<li></li>\r\n <li></li>\r\n<li></li>',
  //   images: ['images/peach_aviation.png', 'images/peach_aviation.png'],
  // },
  {
    type: [
      'Mobile Application',
      'Transport & Logistics',
      'React-JS / Native',
      'USA',
    ],
    name: 'RigBot<br/>Transport Solution',
    client: 'RigBot',
    location: 'USA',
    description:
      '<li><b>E-log</b> is designed for high driver satisfaction. Truck drivers can stop worrying about complex hours of service (HOS) calculations for planning their trips and managing driver-vehicle inspection reports (DVIRs). The app is used to maintain accurate logs and send timely alerts to drivers and dispatch managers on potential violations.</li>\r\n <li><b>E-Stop</b> is designed for truck drivers to book parking slots at various truck stops based on the driver’s ETA. The development was only focussed on the front-end as it was a PoC. It had features like map integration for showing availability of parking spots on the Google map, bay slots availability diagram, booking a bay and count down page for the start time of a given slot for the customer.</li><li>Roles : Design, Development, Testing &amp; Deployment</li>\r\n<li>Technologies : React Native, Android</li>',
    images: [
      'images/rigbot.jpg',
      'images/rigbot/rigbot1.png',
      'images/rigbot/rigbot2.png',
      'images/rigbot/rigbot3.png',
      'images/rigbot/rigbot4.png',
      'images/rigbot/rigbot5.png',
      'images/rigbot/rigbot6.png',
    ],
  },
  {
    type: ['Mobile Application', 'Transport & Logistics', 'India'],
    name: 'Roll on Road<br/>Fleet tracking',
    client: 'Roll on Road',
    location: 'Bangalore India',
    description:
      '<li>Roll On Road, India&#39;s leading fleet tracking platform service provider. As a transport management company they provide detailed truck tracking to consignors and transport company owners. They fit sensors / GPS to trucks that enter their management platform. They are now entering the area of tracking school buses in a similar fashion.</li><li>NicheSolv has written their iOS app to enable this interaction. Their service offering for fleet owners include GPS vehicle tracking solution to control moving assets &amp; for school transportation they offer School 360 solution with enhanced focus on kids safety</li>\r\n <li>Roles: Architecture, Design &amp; Development.</li>\r\n<li>Technologies: iOS &amp; React Native</li>',
    images: ['images/ror.jpg', 'images/ror.png'],
  },
  {
    type: ['Web Application', 'Airlines', 'Node.JS', 'USA'],
    name: 'iFly<br/>Airline',
    client: 'iFly',
    location: 'USA',
    description:
      '<li><a href="http://www.ifly.com" target="_blank"><b>iFly</b></a> is the online resource for getting through and between commercial airports.User can get information on over 700 domestic and international airfields, can track a flight arrival or find airport parking and can use terminal map to find where the airline\'s gate is located.</li><li>iFly helps passengers book their flights, arrive at the right time, park in the right place, get through security and board their plane.</li><li>It also has Content Management System (CMS), an admin tool to add, edit and delete airport,flight, hotel details.</li>\r\n <li>Role: Software Development</li>\r\n<li>Technologies : Handlebars.js, Java, Node.js, AWS, Bootstrap, CSS, MySql </li>',
    images: ['images/ifly.jpg', 'images/ifly.png'],
  },
  {
    type: ['USA', 'Java', 'React-JS / Native', 'Engineering'],
    name: 'Aditazz<br/><br/>',
    client: 'Aditazz',
    location: 'USA',
    description:
      '<li>A factory floor component placement & routing constraint solving platform used by large Chemical Industry planners.</li><li> Role: Front end & Backend development </li><li> Technologies: React-JS, Three.js, HTML, CSS, Javascript, Node.js, Python, Java, JMeter</li><li>Environment: Docker, Kubernetes, Spring Framework, Redis, Grafana</li>',
    images: ['images/aditazz.png'],
  },
  {
    type: ['Quality Assurance', 'Devops', 'USA', 'Java', 'Hiring/L&D'],
    name: 'Rybot <br /><br />',
    client: 'Rybot',
    location: 'USA',
    description:
      '<li>Rybot flagship product Internet Pause Button focused on making lives easier for parents. This IOT device allows parents to simply open an app and pause the internet for their kids. </li> \r\n<li> NicheSolv designed, re-architectured and did end to end performance testing of this. Device simulators helped in simulating websocket connection and listen to the events. jMeter was used to generate different load scenarios. </li> \r\n <li>Roles: Design re-architecture, Performance testing</li>\r\n <li>Technologies: JMeter, Java</li>',
    images: ['images/rybot(1).png'],
  },
  {
    type: ['USA', 'Travel & Leisure', 'Java'],
    name: 'Uplift<br/>Travel now, Pay later <br/>',
    client: 'Uplift',
    location: 'USA',
    description:
      "<b>Uplift Inc Menlo Park, CA</b><br/><br/><b> Client :</b> A silicon valley based fast growth startup in travel fintech is building pay-over-time travel financing solution designed to seamlessly integrate with a travel provider’s existing website or workflow, as well as a hybrid online/offline solution custom-tailored for travel agents and call centers, travel financing through Uplift facilitates higher conversion, increased ancillary uptake and cart size gains across every travel industry segment. It calculates the loan conditions based on a individual's credit score.<br/><br/><b>NicheSolv Work :</b> We have written Javascript which can be included into travel provider’s existing website, which manipulates the DOM to add a pay monthly option to every payment option in the website. We have created Java Rest API backend that integrates with Credit Bureau's credit APIs, calculates individuals' credit scores.<br/>We have used Selenium using Java / Clojure to test various travel provider's websites on a continual basis <li> Roles: Development and Testing</li><li> Technologies : Linux, Java, Javascript, Clojure, TamperMonkey, Gradle, Bamboo, Spring Framework </li>",
    images: ['images/uplift (1).png'],
  },
  {
    type: ['India', 'Transport & Logistics', 'Java'],
    name: 'Inmovidu<br/>mobile application',
    client: 'Inmovidu',
    location: 'India',
    description:
      "<li>NicheSolv built mobile app on react- native which helps track travel & accommodation information, SoS and  sharing of location to trusted contacts for women's safety</li> <li> Roles: Design, Development,Testing & Deployment</li><li> Technologies : React-Native </li>",
    images: [
      'images/inmovidu/inmovidu (2).png',
      'images/inmovidu/sign-in.jpg',
      'images/inmovidu/menu.jpg',
      'images/inmovidu/alerts1.jpg',
      'images/inmovidu/alerts2.jpg',
      'images/inmovidu/itinerary.jpg',
      'images/inmovidu/accommodation.jpg',
      'images/inmovidu/map1.jpg',
      'images/inmovidu/map2.jpg',
      'images/inmovidu/track.jpg',
      'images/inmovidu/weather.jpg',
    ],
  },
  {
    type: ['India', 'HTML / Bootstrap', 'Hiring/L&D'],
    name: 'Akademize<br/><br/>',
    client: 'Akademize',
    location: 'India',
    description:
      '<li><a href="http://www.akademize.com" target="_blank"><b>Akademize</b></a> is a training institution which provides courses in various subjects such as Python, AI/ML/Data Science, NLP, Big Data and much more.</li></br>NicheSolv\'s role:<li>Design a responsive website to allow the users to view available courses and enroll in it.</li><li>AWS S3 site hosting</li><li>Payment gateway integration</li><li> Technologies : HTML, CSS, Bootstrap, Javascript </li>',
    images: [
      'images/Akademize-1.jpg',
      'images/Akademize-2.png',
      'images/Akademize-3.png',
    ],
  },
  {
    type: ['Europe', 'Devops'],
    name: 'Gratte Brothers<br/><br/>',
    client: 'Gratte Brothers',
    location: 'Europe',
    description:
      '<li>Azure DevOps for UK client</li><li>Setting up and monitoring infrastructure including Virtual Machines, Application Gateway and Databases</li><li>Scripted deployment</li><li>Backup and recovery</li><li>SSL Certificate management</li>',
    images: ['images/gratte-brothers-1.png'],
  },
  {
    type: ['India', 'React-JS / Native', 'Node.JS', 'Web Application'],
    name: 'Notum<br/><br/>',
    client: 'Notum',
    location: 'India',
    description:
      '<li>Notum - a web application for monitoring analytics data of multiple websites</li><li>Using google analytics and shopify data of each website, the user is able to see revenue and other key dashboard data.</li><li>Technologies: Node.js, MongoDb, React-JS, AWS Lambda, OAuth2, Google Analytics APIs</li>',
    images: ['images/Notum-1.png', 'images/Notum-1.png'],
  },

  {
    type: ['Mobile Application', 'Flutter', 'India'],
    name: 'ACE<br/><br/>',
    client: 'ACE',
    location: 'India',
    description:
      '<li>A Computer Vision based Machine Learning models to provide analytics/statistics and video highlights for any tennis session. </li><li>Users can either upload a video or set-up the app to record their match/practice sessions and get a complete breakdown of their game, ball-by-ball including shot type, shot accuracy, rally lengths and shot videos down to the last detail. </li><li>Users can add coaches/friends who can view all these details as the session progresses.</li><li>Roles: Development/design/architecture and project execution</li><li>Technologies : Flutter</li>',
    images: [
      'images/AceApp/AceApplogo.png',
      'images/AceApp/Landing1.jpg',
      'images/AceApp/Landing2.jpg',
      'images/AceApp/Landing3.jpg',
      'images/AceApp/Landing4.jpg',
      'images/AceApp/Landing5.jpg',
      'images/AceApp/Landing6.jpg',
    ],
  },

  {
    type: ['India', 'Java', 'Mobile Application'],
    name: 'ACE<br/><br/>',
    client: 'ACE',
    location: 'India',
    description:
      '<li>A player assist tool in the game of Tennis which automatically analyses player video and extracts information and insights to help achieve:</li>\r\n - Performance of specific strokes<br>\r\n - Track of strokes and win/loss per stroke<br>\r\n - Key aspects of playing techniques<br>\r\n - Match-up statistics and insights against opponents<li>Receives data from the mobile app, processes it and stores the data.</li><li>Communicates with message broker Rabbit MQ to notify the AI & ML models on availability of videos/frames for the processing and receives the processed data.</li><li>Technology : Java, RabbitMQ, Spring, Postgres</li>',
    images: [
      'images/AceApp/AceApplogo.png',
      'images/AceApp/Landing1.jpg',
      'images/AceApp/Landing2.jpg',
      'images/AceApp/Landing3.jpg',
      'images/AceApp/Landing4.jpg',
      'images/AceApp/Landing5.jpg',
      'images/AceApp/Landing6.jpg',
    ],
  },

  {
    type: ['India', 'Python', 'Mobile Application', 'AI / ML'],
    name: 'ACE<br/><br/>',
    client: 'ACE',
    location: 'India',
    description:
      "<li>NicheSolv can provide solutions based on Computer Vision and Deep Learning in the domain of Action Recognition for various applications :</li>\r\n - Performance Monitoring in multiple Sports<br>\r\n - Activity Monitoring in difference scenarios<br>\r\n - Action based Video retrieval<br>\r\n - Posture and Motion Analysis<br>\r\n - Video Summarization<li>ACE is for automatic tennis player performance analysis using Deep learning models running on the server and on mobile.</li><li>Takes the recorded video of a tennis match (in near real time) as input and pushes them back to server where Deep learning models are used to predict the strokes, stance of the player, ball tracking and ball bounce.</li><li>Basic statistics and inferences are pushed back into the app in which player/coach or any one in player's selected network can view them via dashboards.</li><li>Accuracy of prediction is close to 80%.</li><li>Technology : Deep Learning (CNN, RNN and YOLO), Computer Vision, Open CV and Python</li>",
    images: [
      'images/AceApp/AceApplogo.png',
      'images/AceApp/Landing1.jpg',
      'images/AceApp/Landing2.jpg',
      'images/AceApp/Landing3.jpg',
      'images/AceApp/Landing4.jpg',
      'images/AceApp/Landing5.jpg',
      'images/AceApp/Landing6.jpg',
    ],
  },

  {
    type: ['Mobile Application', 'Flutter', 'India'],
    name: 'QUIZ app<br/><br/>',
    client: 'QUIZ app',
    location: 'India',
    description:
      '<li>A multi player Quiz app to learn, gain experience,sharpen your memory or show off your skills and earn through a wager based game play</li><li>NicheSolv is the technology partner taking care of the cloud side software</li><li>Roles: UX design, System design , Software Development , Deployment</li><li>Technology : Flutter based mobile app ( iOS/Android ), Java  ,Postgres ,Infra -GitHub, AWS</li>',
    images: [
      'images/QuizApp/QuizAppLogo.png',
      'images/QuizApp/QuizAppImage1.png',
      'images/QuizApp/QuizAppImage2.png',
      'images/QuizApp/QuizAppImage3.jpg',
      'images/QuizApp/QuizAppImage4.jpg',
    ],
  },

  {
    type: ['India', 'Odoo ERP Integration'],
    name: 'SCube ERP integration<br/><br/>',
    client: 'SCube Ergonomics',
    location: 'India',
    description:
      '<li>Implemented Odoo ERP cloud based solution for the customer.</li><li>Activities: business requirement, configuration, customization development, User Testing and Training, Data Migration and Go-live support.</li><li>Complete integration of activities: Sales, Purchase, Inventory and Accounting.</li><li>Role : ERP Implementation Partner</li> <li>Technology : Odoo ERP, Python and related technologies</li>',
    images: [
      'images/SCube/SCubelogo.png',
      'images/SCube/Landing1.png',
      'images/SCube/Landing2.png',
    ],
  },

  {
    type: ['India', 'AI / ML', 'Python'],
    name: 'Face recognition<br/><br/>',
    client: 'Face recognition',
    location: 'India',
    description:
      "<li>Used Face Recognition to confirm attendance and in particular monitoring Entry Admission system.</li><li>Detect Mask compliance and explore Social distance Compliance.</li><li>Implemented by Interns under NicheSolv's supervision.</li><li>Methods: Python, OpenCV, Deep Learning, YOLO.</li><li>Yielded good results with almost 100% accuracy.</li>",
    images: ['images/FaceRecognition/FaceRecognitionLogo.png'],
  },

  {
    type: ['Mobile Application', 'Flutter', 'India'],
    name: 'Plan Ahead<br/><br/>',
    client: 'Plan Ahead',
    location: 'India',
    description:
      '<li>PlanAhead is a task management app. It has an Admin panel with the functionality of add, delete, update and assign tasks to users with a due date. It has a mobile app where users will receive respective tasks and they can give their feedback as well.</li><li>The app is being developed for Android,iOS and web.</li><li>Roles : Mobile app Development</li><li>Technologies : Flutter App, Flutter Web, FireBase and Fastlane</li>',
    images: [
      'images/PlanAhead/planAheadLogo.png',
      'images/PlanAhead/planAhead1.png',
      'images/PlanAhead/planAhead2.png',
      'images/PlanAhead/planAhead3.png',
      'images/PlanAhead/planAhead4.png',
      'images/PlanAhead/planAhead5.png',
      'images/PlanAhead/planAhead6.png',
      'images/PlanAhead/planAheadMobile1.jpg',
      'images/PlanAhead/planAheadMobile2.jpg',
      'images/PlanAhead/planAheadMobile3.jpg',
    ],
  },

  {
    type: ['Mobile Application', 'Java', 'India'],
    name: 'Saigeware<br/><br/>',
    client: 'Saigeware',
    location: 'India',
    description:
      '<li>Saigeware has a family of medical apps named AIPro2, AyuPro and Ayu-My3. It has functionality to check Pulse rate, respiratory rate and SPO2 along with ayurvedic Vata, Pitta and Kapha values. It has features to connect users on live video call, screen share and chat as well.</li><li>Roles : Mobile app Development, UI & UX Development</li><li>Technologies: Native Android (Java), AWS Amplify, API Integration, Moxtra Integration, Google Map Integration</li>',
    images: [
      'images/Saigeware/saigewareLogo.png',
      'images/Saigeware/saigeware1.jpeg',
      'images/Saigeware/saigeware2.jpeg',
      'images/Saigeware/saigeware3.jpeg',
      'images/Saigeware/saigeware4.jpeg',
      'images/Saigeware/saigeware5.jpeg',
      'images/Saigeware/saigeware6.jpeg',
      'images/Saigeware/saigeware7.jpeg',
      'images/Saigeware/saigeware8.jpeg',
      'images/Saigeware/saigeware9.jpeg',
      'images/Saigeware/saigeware10.jpeg',
      'images/Saigeware/saigeware11.jpeg',
      'images/Saigeware/saigeware12.jpeg',
      'images/Saigeware/saigeware13.jpeg',
      'images/Saigeware/saigeware14.jpeg',
      'images/Saigeware/saigeware15.jpeg',
      'images/Saigeware/saigeware16.jpeg',
      'images/Saigeware/saigeware17.jpeg',
    ],
  },
]
export default DATA



// WEBPACK FOOTER //
// /home/reetika/Desktop/nichesolvweb/website/nswebsite/src/containers/projects/projectsData.js